import { Button } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { RouteScheduleItemEdit } from "./route-schedule-item.edit";
import {
  emptyRouteSchedule,
  IRouteScheduleForm,
} from "./table-route-schedule.models";

export const RouteScheduleItemAdd: FC<IRouteScheduleForm> = ({
  index,
  setValue,
  fieldName,
  onEditStart,
  onEditEnd,
}) => {
  const { t } = useTranslation();
  const [isAddNewOpened, setAddNewOpenedState] = useState(false);

  useEffect(() => {
    if (isAddNewOpened) {
      onEditStart?.();
    } else {
      onEditEnd?.();
    }
  }, [isAddNewOpened, onEditStart, onEditEnd]);

  return (
    <>
      {isAddNewOpened && (
        <RouteScheduleItemEdit
          fieldName={fieldName}
          setValue={setValue}
          value={emptyRouteSchedule}
          index={index}
          onCancel={() => {
            setAddNewOpenedState(false);
          }}
        />
      )}
      {!isAddNewOpened && (
        <Button
          type="button"
          className="add_button"
          onClick={() => setAddNewOpenedState(true)}
        >
          {t("general.APPEND")}
        </Button>
      )}
    </>
  );
};
